import { render } from "./portal-home.vue?vue&type=template&id=90d55dc8&scoped=true"
import script from "./portal-home.vue?vue&type=script&lang=js"
export * from "./portal-home.vue?vue&type=script&lang=js"

import "./portal-home.vue?vue&type=style&index=0&id=90d55dc8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d55dc8"]])

export default __exports__